import React from "react";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const teamMembers = [
    {
      name: "The Curator",
      hobby: "Building calm, color-balanced desk sets",
      favoriteFood: "Citrus tea",
      productChoice: "Meridian Ceramic Rollerball Pen",
      image: "/generated/site/about-curator.jpg"
    },
    {
      name: "The Maker",
      hobby: "Studying glass, glaze, and small handmade details",
      favoriteFood: "Berry tart",
      productChoice: "Verdant Tide Spiral Glass Dip Pen",
      image: "/generated/site/about-maker.jpg"
    },
    {
      name: "The Paper Fan",
      hobby: "Testing pens on every kind of paper",
      favoriteFood: "Honey toast",
      productChoice: "Ivory Exposed-Stitch Journal",
      image: "/generated/site/about-paper.jpg"
    },
    {
      name: "The Packer",
      hobby: "Turning useful supplies into gift-ready bundles",
      favoriteFood: "Apple pie",
      productChoice: "Original Stationery Bundle",
      image: "/generated/site/about-packer.jpg"
    },
    {
      name: "The Listener",
      hobby: "Collecting customer notes and better desk ideas",
      favoriteFood: "Cinnamon roll",
      productChoice: "Quick-Dry Executive Gel Pen",
      image: "/generated/site/about-listener.jpg"
    }
  ];

  return (
    <div className="about">
      <main>
        <section className="about-intro">
          <div className="about-container">
            <h1 className="about-title">Get to know slayfulpawsco 🤗</h1>
            <p className="about-intro-text">
              <strong>slayfulpawsco</strong> is an independent online stationery shop focused on playful, useful tools for writing, planning, and making. We choose tactile materials, calm colors, and small details that make an everyday desk feel more personal.
            </p>
          </div>
        </section>

        <section className="about-mission">
          <div className="about-container">
            <h2 className="section-title">Our Mission 💪</h2>
            <p className="section-text">
              At <strong>slayfulpawsco</strong>, we believe stationery should be dependable enough for daily work and delightful enough to invite a fresh idea. Our mission is to offer a clear, carefully described collection that helps customers choose tools with confidence.
            </p>

            <h2 className="section-title">Our Vision 🤔</h2>
            <p className="section-text">
              Our goal is to grow a distinctive collection of writing and paper goods while keeping the experience simple, warm, and useful. We favor considered materials and original presentation over passing trends.
            </p>

            <h2 className="section-title">Our Value 💎</h2>
            <p className="section-text">
              <strong>Clarity, Care, and Reliability</strong><br />
              We aim to describe materials and dimensions plainly, present every item with original imagery, and support each order with responsive communication. Questions are always welcome at <strong>phase@slayfulpawsco.cloud</strong>.
            </p>
          </div>
        </section>

        <section className="about-team">
          <div className="about-container">
            <h2 className="team-title">Meet the team</h2>
            <p className="team-subtitle">five notes from behind the studio desk</p>
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-member">
                  <div className="member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-hobby"><strong>Hobby:</strong> {member.hobby}</p>
                  <p className="member-food"><strong>Favorite food:</strong> {member.favoriteFood}</p>
                  <p className="member-product"><strong>Product Choice:</strong> <Link to="/shop" onClick={toTop}>{member.productChoice}</Link></p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default About;
